import ReactDOM from 'react-dom';

class StickyWindow {
  constructor({ element, contentElement: ContentElement }) {
    this.element = element;
    this.overlay = element.querySelector('.sticky-window__overlay');
    this.content = element.querySelector('.sticky-window__content');
    this.closeButton = element.querySelector('.sticky-window__close-button');
    ReactDOM.render(ContentElement, this.content);
    this.addEvents();
  }

    handleOverlayClick = (e) => {
      e.preventDefault();
      this.element.dispatchEvent(new CustomEvent('overlay:click', {
        detail: {}
      }));
    }

    handleCloseClick = (e) => {
      this.element.dispatchEvent(new CustomEvent('close:click', {
        detail: {}
      }));
    }

    addEvents() {
      this.overlay.addEventListener('click', this.handleOverlayClick);
      this.closeButton.addEventListener('click', this.handleCloseClick);
    }

    removeEvents() {
      this.overlay.removeEventListener('click', this.handleOverlayClick);
      this.closeButton.addEventListener('click', this.handleCloseClick);
    }

    show() {
      this.element.classList.remove('sticky-window-hide');
      this.element.classList.add('sticky-window-un-hide');
    }

    open() {
      this.element.classList.remove('sticky-window-hide');
      this.element.classList.remove('sticky-window-un-hide');
      this.element.classList.add('sticky-window-open');
    }

    hide() {
      this.element.classList.remove('sticky-window-un-hide');
      this.element.classList.add('sticky-window-hide');
    }

    close() {
      this.element.classList.remove('sticky-window-un-hide');
      this.element.classList.remove('sticky-window-hide');
      this.element.classList.remove('sticky-window-open');
      ReactDOM.unmountComponentAtNode(this.content);
    }

    on(event, callback) {
      this.element.addEventListener(event, callback);
    }

    off(event, callback) {
      this.element.removeEventListener(event, callback);
    }

    destroy() {
      this.removeEvents();
      if (this.swiper) this.swiper.destroy();
    }
}

export default StickyWindow;
